import { format, formatDistanceToNow } from "date-fns";

// ── Status ────────────────────────────────────────────────────
export const STATUS = {
  active:  { color:"#6af7c4", bg:"rgba(106,247,196,0.12)", border:"rgba(106,247,196,0.3)", label:"ACTIVE"  },
  idle:    { color:"#f7c46a", bg:"rgba(247,196,106,0.12)", border:"rgba(247,196,106,0.3)", label:"IDLE"    },
  offline: { color:"#4d6680", bg:"rgba(77,102,128,0.12)",  border:"rgba(77,102,128,0.3)",  label:"OFFLINE" },
  sos:     { color:"#ff4466", bg:"rgba(255,68,102,0.15)",  border:"rgba(255,68,102,0.5)",  label:"SOS !"   },
};

export const ALERT_TYPES = {
  message:   { icon:"💬", label:"Message",   color:"#7c6af7" },
  task:      { icon:"📋", label:"Task",      color:"#6af7c4" },
  sos:       { icon:"🚨", label:"SOS",       color:"#ff4466" },
  broadcast: { icon:"📢", label:"Broadcast", color:"#f7c46a" },
  warning:   { icon:"⚠️", label:"Warning",   color:"#f7c46a" },
};

export const PRIORITY = {
  critical: { color:"#ff4466", bg:"rgba(255,68,102,0.12)", label:"CRITICAL" },
  high:     { color:"#f7c46a", bg:"rgba(247,196,106,0.1)", label:"HIGH"     },
  normal:   { color:"#7c6af7", bg:"rgba(124,106,247,0.1)", label:"NORMAL"   },
};

export const ALERT_STATUS = {
  active: { color:"#ff4466", label:"ACTIVE" },
  sent:   { color:"#f7c46a", label:"SENT"   },
  ack:    { color:"#6af7c4", label:"ACK"    },
};

// ── Formatters ────────────────────────────────────────────────
export const fmt = {
  time:     ts => { try { return format(new Date(ts), "hh:mm:ss a"); } catch { return "—"; } },
  date:     ts => { try { return format(new Date(ts), "dd MMM yyyy"); } catch { return "—"; } },
  datetime: ts => { try { return format(new Date(ts), "dd MMM, hh:mm a"); } catch { return "—"; } },
  ago:      ts => { try { return formatDistanceToNow(new Date(ts), { addSuffix: true }); } catch { return "—"; } },
  coord:    n  => n ? n.toFixed(5) : "—",
  speed:    s  => s !== undefined ? `${s} km/h` : "—",
};

// ── Battery ───────────────────────────────────────────────────
export const batteryColor = pct =>
  pct > 40 ? "#6af7c4" : pct > 15 ? "#f7c46a" : "#ff4466";

export const batteryIcon = pct =>
  pct > 60 ? "🔋" : pct > 20 ? "🪫" : "❗";

// ── Compass heading ───────────────────────────────────────────
export const headingLabel = deg => {
  const dirs = ["N","NE","E","SE","S","SW","W","NW"];
  return dirs[Math.round(deg / 45) % 8];
};

// ── Color ─────────────────────────────────────────────────────
export const hexAlpha = (hex, a) => {
  const r = parseInt(hex.slice(1,3),16);
  const g = parseInt(hex.slice(3,5),16);
  const b = parseInt(hex.slice(5,7),16);
  return `rgba(${r},${g},${b},${a})`;
};
